/** How far back every year picker reaches — the client's "5 years of history" (meeting 2026-10-06). */
export const YEARS_BACK = 5;
/** And how far ahead: one year, for next year's intake. */
export const YEARS_AHEAD = 1;

/**
 * The years every year picker offers, newest first: next year down to five years ago. One rule for
 * the whole app — the pickers had grown six different ranges, from four years to seventeen.
 *
 * <p>Its Java twin is {@code DateHelper.reportingYears()}, which the server-rendered pickers use
 * through {@code @dateHelper}; change both together. Calendars are not year pickers in this sense
 * and keep their own range.</p>
 */
export function reportingYears(now: Date = new Date()): number[] {
    const current = now.getFullYear();
    const years: number[] = [];
    for (let year = current + YEARS_AHEAD; year >= current - YEARS_BACK; year--) years.push(year);
    return years;
}
